export default __webpack_public_path__ + "static/media/portfolio-43.9eb2b75b.jpg";